/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ServiceObjectBaseV1Dto = {
  /**
   * The unique identifier of the entity.
   */
  readonly id: string;
  /**
   * The date when the entity was created.
   */
  readonly createdAt: string;
  /**
   * The date when the entity was modified.
   */
  readonly modifiedAt: string;
  /**
   * The current version of the entity
   */
  version: number;
  /**
   * Comments related to the service object
   */
  comments?: string;
  /**
   * Construction year of the service object
   */
  constructionYear?: number;
  /**
   * Inventory number of the service object
   */
  inventoryNumber?: string;
  /**
   * Manufacturer of the service object
   */
  manufacturer: string;
  /**
   * Model of the service object
   */
  model: string;
  /**
   * Name of the service object
   */
  name: string;
  /**
   * Responsibility of the service object
   */
  responsibleRole: ServiceObjectBaseV1Dto.responsibleRole;
  /**
   * Serial number of the service object
   */
  serialNumber?: string;
};
export namespace ServiceObjectBaseV1Dto {
  /**
   * Responsibility of the service object
   */
  export enum responsibleRole {
    CUSTOMER = 'Customer',
    LANDLORD = 'Landlord',
    MAINTENANCE = 'Maintenance',
    PARTNER = 'Partner',
  }
}
